export const media = {
    phoneSmall: '@media (min-width: 300px)',
    phoneLarge: '@media (min-width: 400px)',
    tabletSmall: '@media (min-width: 600px)',
    tabletLarge: '@media (min-width: 800px)',
    desktop: '@media (min-width: 1000px)',
    desktopLarge: '@media (min-width: 1200px)',
};
